import React from 'react';
import './Home.css';
import './Contact.css';

export default function Contact() {
  return (
    <div className="simple-page">
      <div className="page-inner">

        <p className="section-label">CONTACT</p>

        <h2>
          Investment & Partnership Inquiries
        </h2>

        <p className="section-text">
          We welcome inquiries from institutional investors, strategic partners,
          and project developers seeking collaboration opportunities in infrastructure
          and energy investments.
        </p>

        <div className="contact-grid">
          <div className="contact-card">
            <h3>Investor Relations & Business Inquiries</h3>

            <div className="contact-info">
              <p><strong>Email</strong></p>
              <p>
                <a className="contact-link" href="mailto:info@leejininvestment.com">
                  info@leejininvestment.com
                </a>
              </p>
            </div>
          </div>

          <div className="contact-card">
            <h3>Head Office (Seoul)</h3>
            <p>
              LEEJIN Investment Co., Ltd.
            </p>

            <div className="contact-info">
              <p>
                9F, 465, Bongeunsa-ro, Gangnam-gu, Seoul, Republic of Korea
              </p>
            </div>
          </div>

        </div>

      </div>
    </div>
  );
}
